import { PDFCompanyInfoV2 } from "./PDFCompanyInfo";
import { pdfFz } from "./stylesPDFv2";

/**
 * Bloque de datos del cliente + proyecto / dirección de entrega.
 * Reutiliza la caja de dos columnas; semánticamente separado para claridad
 * y para poder evolucionar el cliente sin afectar otras cajas.
 
 *
 * @param {Array<{label,value}>} left  datos del cliente
 * @param {Array<{label,value}>} right proyecto / dirección de entrega
 */
export const PDFClientInfoV2 = ({ left = [], right = [] } = {}) =>
  PDFCompanyInfoV2({
    left,
    right,
    labelWidthLeft: "42%",
    labelWidthRight: "32%",
    fontSize: pdfFz(6), // 1pt menos que el cuerpo (bloque 2: datos del cliente)
  });

export default PDFClientInfoV2;